import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { navigateWithFeedback } from '../utils/navigationFeedback';
import { useI18n } from '../i18n';

export default function FloatingAppBar() {
  const [footerOffset, setFooterOffset] = useState(0);
  const appBarRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useI18n();

  const actions = [
    { label: t('nav.catalog'), target: '/product' },
    { label: t('nav.company'), target: '/', section: 'company' },
    { label: t('nav.documents'), target: '/', section: 'documents' },
    { label: t('nav.phone'), href: 'tel:+79043032224' },
  ];

  useEffect(() => {
    const updateFooterOffset = () => {
      const footer = document.querySelector('.site-footer');
      if (!footer) {
        setFooterOffset(0);
        return;
      }

      const footerTop = footer.getBoundingClientRect().top;
      const overlap = Math.max(0, window.innerHeight - footerTop);
      setFooterOffset(overlap);
    };

    updateFooterOffset();
    window.addEventListener('scroll', updateFooterOffset, { passive: true });
    window.addEventListener('resize', updateFooterOffset);

    return () => {
      window.removeEventListener('scroll', updateFooterOffset);
      window.removeEventListener('resize', updateFooterOffset);
    };
  }, []);

  const handleClick = (action) => {
    if (action.href) {
      window.location.href = action.href;
      return;
    }

    navigateWithFeedback({
      currentPath: location.pathname,
      navigate,
      section: action.section,
      target: action.target,
      delay: 90,
      message: t('nav.alreadyHere'),
    });
  };

  return (
    <nav
      className="floating-app-bar"
      aria-label={t('nav.quickNavigation')}
      ref={appBarRef}
      style={{ '--footer-offset': `${footerOffset}px` }}
    >
      {actions.map((action) =>
        action.href ? (
          <a
            className={action.highlight ? 'is-highlighted' : undefined}
            href={action.href}
            key={action.label}
          >
            {action.label}
          </a>
        ) : (
          <button
            className={action.highlight ? 'is-highlighted' : undefined}
            key={action.label}
            onClick={() => handleClick(action)}
          >
            {action.label}
          </button>
        )
      )}
    </nav>
  );
}
